<template>
  <form @submit.prevent="setValue" class="relative max-w-sm mx-auto">
    <input type="text" class="border p-3 pr-12 w-full" placeholder="キーワードで検索する" v-model="search">
    <span class="material-icons absolute right-0 top-0 p-3"
      @click="setValue"
    >search</span>
  </form>
</template>

<script>
export default {
  props: {
    value: { type: String, required: true }
  },
  data() {
    return {
      search: this.value
    }
  },
  methods: {
    setValue() {
      this.$emit('input', this.search);
    }
  },
  watch: {
    search(v) {
      if(!v) this.$emit('input', '');
    }
  }
}
</script>
